// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__YNFJQ","rows":"style_rows__DKQV-","confirmedNumber":"style_confirmedNumber__6tDS4"};